import localforage from 'localforage';

const profileStorage = localforage.createInstance({
  name: 'GoPlausible-Algorand-Agency',
  storeName: 'profiles',
  version: 1.0,
  description: 'Algorand Agency platform profiles storage'
});

export const profileStore = {
  async getProfile(walletAddress: string) {
    try {
      return await profileStorage.getItem(`profile_${walletAddress}`);
    } catch (error) {
      console.error('Error getting profile from storage:', error);
      return null;
    }
  },

  async setProfile(walletAddress: string, profile: any) {
    try {
      await profileStorage.setItem(`profile_${walletAddress}`, profile);
    } catch (error) {
      console.error('Error setting profile in storage:', error);
      throw error;
    }
  },

  async removeProfile(walletAddress: string) {
    try {
      await profileStorage.removeItem(`profile_${walletAddress}`);
    } catch (error) {
      console.error('Error removing profile from storage:', error);
      throw error;
    }
  },

  async clear() {
    try {
      await profileStorage.clear();
    } catch (error) {
      console.error('Error clearing profile storage:', error);
      throw error;
    }
  }
};